var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#359e81;}.b,.c{fill:none;}.c{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8.5,
    cy: 8.5,
    r: 8.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.238 3.238)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10.524,
    height: 10.524,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.016,6,6.192,10.823,4,8.631",
    transform: "translate(-2.465 -3.15)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.d511cd358cfef9ad3fbae688104ccd00.svg";
export { ForwardRef as ReactComponent };